<template>
  <div class="gov-play-detail">
    <div class="container">
      <div
        class="flex"
        style="align-items: center;margin-bottom: 25px;padding-top: 25px;"
      >
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/govInfo' }"
            >政务信息</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="titleInfo.titleForm === 'govLiveList'"
            :to="{ path: '/govLiveList' }"
          >
            直播列表
          </el-breadcrumb-item>
          <el-breadcrumb-item
            v-else-if="titleInfo.titleForm === 'govVideoList'"
            :to="{ path: '/govVideoList' }"
          >
            视频列表
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{
            titleInfo.type === "video" ? "视频详情" : "直播详情"
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <div class="live-box player" v-if="curType === 'video'">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
          >
          </video-player>
        </div>
        <div v-if="curType === 'live'">
          <iframe
            class="live-box"
            :src="curItem.url"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="play-info">
        <el-card>
          <div class="info-title">
            {{ titleInfo.type === "video" ? "视频简介" : "直播简介" }}
          </div>
          <div class="info-line" />
          <div v-html="curItem.content"></div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { videoPlayer } from "vue-video-player"

import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"
import { getGovLiveDetail, getGovVideoDetail } from "../../utils/interface"

export default {
  //   播放详情详情页
  name: "saasDetails",
  metaInfo: {
    title: "播放详情-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台播放详情提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {
    videoPlayer,
  },
  data() {
    return {
      curType: "", //video:视频 live:直播
      curUuid: "",
      curItem: "",
      detailInfo: {},
      titleInfo: {
        titleName: "直播列表",
        titleForm: "govLiveList",
        type: "video",
      },
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: this.videoUrl, //你的视频地址（必填）
          },
        ],
        poster: "", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //        controlBar: {
        //          timeDivider: true,
        //          durationDisplay: true,
        //          remainingTimeDisplay: false,
        //          fullscreenToggle: true  //全屏按钮
        //        }
      },
    }
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  created() {
    this.getParams()
  },
  methods: {
    getParams() {
      this.curUuid = this.$route.query.uuid
      this.titleInfo.titleName = this.$route.query.titleName
      this.titleInfo.titleForm = this.$route.query.titleForm
      this.titleInfo.type = this.$route.query.type
      this.getDetailByUuid()
    },
    getDetailByUuid() {
      let that = this
      let api =
        this.$route.query.type === "video"
          ? getGovVideoDetail
          : getGovLiveDetail
      api(this.curUuid).then((res) => {
        if (res.data) {
          this.curItem = res.data
          // source: 1：上传   0：地址
          if (this.$route.query.type === "video" && this.curItem.source === 1) {
            this.curType = "video"
          } else {
            this.curType = "live"
          }

          if (this.curType === "video") {
            // this.playerOptions.poster = this.curItem.pic;
            this.playerOptions.sources[0].src = this.curItem.url
            // this.$refs.videoPlayer.player()

            //禁用提示
            that.$nextTick(() => {
              let a = document.getElementsByClassName("vjs-big-play-button")
              let b = document.getElementsByClassName("vjs-play-control")
              let c = document.getElementsByClassName("vjs-mute-control")
              let d = document.getElementsByClassName("vjs-fullscreen-control")
              a[0].setAttribute("title", "")
              b[0].setAttribute("title", "")
              c[0].setAttribute("title", "")
              d[0].setAttribute("title", "")
            })
          }
        }
      })
    },
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
  },
}
</script>

<style scoped lang="less">
/deep/ .vjs-custom-skin > .video-js .vjs-big-play-button {
  width: 72px;
  height: 72px;
  border-radius: 100% !important;
  z-index: 100;
  background-color: #ffffff30;
  border: solid 2px #efefef;
}

/deep/ .vjs-poster {
  background-color: #0000;
}

.gov-play-detail {
  background: #f4f4f4;

  .overflow-ellipsis {
    //整体超出部分隐藏
    overflow: hidden;
    //文本超出部分以...形式展示，同第一行样式代码
    text-overflow: ellipsis;
    //display 块级元素展示
    display: -webkit-box;
    //设置文本行数为2行
    -webkit-line-clamp: 2;
    //设置文本行数为2行
    line-clamp: 2;
    //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
    -webkit-box-orient: vertical;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    background-color: #efefef;
    min-height: 100%;
  }

  .video-js .vjs-big-play-button {
    width: 72px;
    height: 72px;
    border-radius: 100% !important;
    z-index: 100;
    //background-color: #ffffff;
    border: solid 1px #efefef;
  }

  .live-box {
    width: 1200px;
    height: 710px;
  }

  .play-info {
    margin-top: 40px;

    .info-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }

    .info-line {
      margin: 20px 0;
      width: 100%;
      height: 1px;
      background-color: #e3e3e3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/govInfo/playDetail.vue